import { useState } from "react";
import { toast } from "sonner";
import { Copy, Loader2, Send } from "lucide-react";
import { PhonePeBadge, RailChip } from "../payments/RailSelector";

export function PhaseRailLinks({ api, invite, onChange }) {
  const [busy, setBusy] = useState(false);
  const rails = invite.rail_links || {};
  const have = Object.keys(rails);
  if (!have.length) return null;
  const current = invite.payment_rail || "razorpay";

  const copy = async (url, label) => {
    try { await navigator.clipboard.writeText(url); toast.success(`${label} copied`); } catch { toast.error("Could not copy"); }
  };
  const dispatch = async (rail) => {
    setBusy(true);
    try {
      const r = await api.post(`/admin/vcb/invites/${invite.id}/dispatch`, { rail, send: true });
      toast.success(`${rail === "phonepe" ? "PhonePe" : "Razorpay"} links dispatched to ${invite.email}`, { description: r.data.sent ? "Email sent" : "Email suppressed by comms switch" });
      await onChange?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Dispatch failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5" data-testid={`vcb-rail-links-${invite.id}`}>
      <RailChip rail={current} />
      {["razorpay", "phonepe"].filter((r) => rails[r]).map((r) => (
        <div key={r} className="inline-flex items-center border border-white/10 rounded-sm overflow-hidden">
          {["1", "2"].filter((ph) => rails[r][ph]?.short_url).map((ph) => (
            <button key={ph} onClick={() => copy(rails[r][ph].short_url, `${r === "phonepe" ? "PhonePe" : "Razorpay"} Phase ${ph} link`)}
                    data-testid={`vcb-copy-${r}-p${ph}-${invite.id}`}
                    title={`Copy ${r === "phonepe" ? "PhonePe" : "Razorpay"} Phase ${ph} link`}
                    className="inline-flex items-center gap-1 px-2 py-1 font-grotesk text-[9px] uppercase tracking-[0.16em] text-[#C9C9C2] hover:bg-white/5 border-r border-white/10 last:border-r-0">
              {r === "phonepe" ? <PhonePeBadge size={11} /> : <span className="w-[11px] h-[11px] rounded-[2px] bg-[#4285F4] inline-block" />}
              <Copy size={10} /> P{ph}
            </button>
          ))}
          {r !== current && (
            <button onClick={() => dispatch(r)} disabled={busy} data-testid={`vcb-dispatch-${r}-${invite.id}`}
                    title={`Dispatch ${r === "phonepe" ? "PhonePe" : "Razorpay"} links to partner`}
                    className="inline-flex items-center gap-1 px-2 py-1 font-grotesk text-[9px] uppercase tracking-[0.16em] text-[#D8B23E] hover:bg-[#D8B23E]/10">
              {busy ? <Loader2 size={10} className="animate-spin" /> : <Send size={10} />} Use
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
